var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "data-page" },
    [
      _c(
        "tooltipLine",
        {
          attrs: {
            tip:
              _vm.$store.state.language === "en"
                ? require("@/assets/images/ad-en.png")
                : require("@/assets/images/ad.png"),
            visible:
              !(
                _vm.$store.state.user.hasBindData &&
                _vm.$store.state.user.hasBindData.isExistAds
              ) && _vm.$store.state.user.sourceType !== 2,
            content: _vm.$t("ad-analysis::auth_tooltip"),
          },
        },
        [
          _c("span", { attrs: { slot: "btn" }, slot: "btn" }, [
            _c(
              "span",
              {
                staticClass: "bind-btn",
                on: {
                  click: function ($event) {
                    return _vm.onSetAd("fb")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("ad-analysis::auth_fb")))]
            ),
            _c(
              "span",
              {
                staticClass: "bind-btn",
                on: {
                  click: function ($event) {
                    return _vm.onSetAd("google")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("ad-analysis::auth_google")))]
            ),
          ]),
        ]
      ),
      _c(
        "el-row",
        { attrs: { type: "flex", justify: "space-between" } },
        [
          _c(
            "el-col",
            { attrs: { xl: 10, lg: 10, md: 10, sm: 10, xs: 10 } },
            [
              _c(
                "el-button",
                {
                  attrs: { type: _vm.params.adSource === 0 ? "primary" : "" },
                  on: {
                    click: function ($event) {
                      return _vm.changeSource(0)
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("ad-analysis::tab_all")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: _vm.params.adSource === 1 ? "primary" : "" },
                  on: {
                    click: function ($event) {
                      return _vm.changeSource(1)
                    },
                  },
                },
                [_vm._v("Facebook")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: _vm.params.adSource === 2 ? "primary" : "" },
                  on: {
                    click: function ($event) {
                      return _vm.changeSource(2)
                    },
                  },
                },
                [_vm._v("Google")]
              ),
            ],
            1
          ),
          _c(
            "el-col",
            {
              staticClass: "right-content",
              attrs: { xl: 14, lg: 14, md: 14, sm: 14, xs: 14 },
            },
            [
              _c("z-select", {
                staticStyle: { "margin-right": "20px", width: "180px" },
                attrs: {
                  filterable: "",
                  placeholder: _vm.$t("ad-analysis::placeholder_shop"),
                  options: _vm.shopList,
                  popperAppendToBody: false,
                },
                on: { change: _vm.reset },
                model: {
                  value: _vm.params.brandId,
                  callback: function ($$v) {
                    _vm.$set(_vm.params, "brandId", $$v)
                  },
                  expression: "params.brandId",
                },
              }),
              _c("span", { staticStyle: { width: "50px" } }, [
                _vm._v(_vm._s(_vm.$t("ad-analysis::date")) + "："),
              ]),
              _c("el-date-picker", {
                staticStyle: { width: "265px" },
                attrs: {
                  appendToBody: false,
                  clearable: false,
                  type: "daterange",
                  align: "right",
                  "unlink-panels": "",
                  "range-separator": _vm.$t("system::time::text::include"),
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                  "picker-options": _vm.pickerOptions,
                },
                on: { change: _vm.handlerDateChange },
                model: {
                  value: _vm.date,
                  callback: function ($$v) {
                    _vm.date = $$v
                  },
                  expression: "date",
                },
              }),
              _c(
                "el-select",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.params.adSource !== 2,
                      expression: "params.adSource !== 2",
                    },
                  ],
                  staticClass: "select-item",
                  on: { change: _vm.getAllData },
                  model: {
                    value: _vm.params.click_value,
                    callback: function ($$v) {
                      _vm.$set(_vm.params, "click_value", $$v)
                    },
                    expression: "params.click_value",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "1 Click", value: "one_day_click" },
                  }),
                  _c("el-option", {
                    attrs: { label: "7 Click", value: "seven_day_click" },
                  }),
                ],
                1
              ),
              _c(
                "el-select",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.params.adSource !== 2,
                      expression: "params.adSource !== 2",
                    },
                  ],
                  staticClass: "select-item",
                  staticStyle: { "margin-left": "0" },
                  on: { change: _vm.getAllData },
                  model: {
                    value: _vm.params.view_value,
                    callback: function ($$v) {
                      _vm.$set(_vm.params, "view_value", $$v)
                    },
                    expression: "params.view_value",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "1 View", value: "one_day_view" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { display: "flex", "align-items": "center" } },
        [
          _c(
            "el-row",
            {
              staticStyle: { flex: "1" },
              attrs: { type: "flex", justify: "space-between", gutter: 20 },
            },
            _vm._l(_vm.cardOptions, function (item, index) {
              return _c(
                "el-col",
                { key: index },
                [
                  _c("dataCard", {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    staticClass: "ad-anaylsis-card",
                    attrs: { active: "", option: item },
                  }),
                ],
                1
              )
            }),
            1
          ),
          _c(
            "el-card",
            { staticStyle: { "margin-left": "20px", "margin-top": "10px" } },
            [
              _c(
                "div",
                { staticClass: "setting", on: { click: _vm.ruleSetting } },
                [
                  _c("i", {
                    staticClass: "iconfont icona-15shezhi",
                    staticStyle: { "font-size": "24px", color: "#999" },
                  }),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "margin-top": "8px",
                        "font-size": "12px",
                        color: "#999",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("system::rbac::设置")))]
                  ),
                ]
              ),
            ]
          ),
        ],
        1
      ),
      _c(
        "el-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.params.adSource === 0,
              expression: "params.adSource === 0",
            },
          ],
          attrs: { gutter: 20 },
        },
        [
          _c(
            "el-col",
            { attrs: { lg: 8, md: 24, sm: 24, xl: 8 } },
            [
              _c("reportCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingSale.adCostTop,
                    expression: "loadingSale.adCostTop",
                  },
                ],
                style: "height: " + _vm.reportHeight + ";",
                attrs: { config: _vm.adCostTop },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 8, md: 24, sm: 24, xl: 8 } },
            [
              _c("reportCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingSale.payamountTop,
                    expression: "loadingSale.payamountTop",
                  },
                ],
                style: "height: " + _vm.reportHeight + ";",
                attrs: { config: _vm.payamountTop },
              }),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 8, md: 24, sm: 24, xl: 8 } },
            [
              _c("reportCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingSale.roiTop,
                    expression: "loadingSale.roiTop",
                  },
                ],
                style: "height: " + _vm.reportHeight + ";",
                attrs: { config: _vm.roiTop },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.params.adSource === 0,
              expression: "params.adSource === 0",
            },
          ],
          attrs: { gutter: 20 },
        },
        [
          _c(
            "el-col",
            { attrs: { lg: 12, md: 24, sm: 24, xl: 12 } },
            [
              _c(
                "reportTable",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loadingSale.campaignTop,
                      expression: "loadingSale.campaignTop",
                    },
                  ],
                  style: "height: " + _vm.reportHeight + ";",
                  attrs: { config: _vm.campaignTop },
                  on: { change: _vm.getCampaignTop },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t("ad-analysis::广告系列名称"),
                      "show-overflow-tooltip": true,
                      "min-width": "100",
                      prop: "campaignName",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "adSpend",
                      label: _vm.$t("ad-analysis::cost_title"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$dataCheck(
                                    _vm.formatNumberMix(
                                      scope.row.adSpend,
                                      2,
                                      ""
                                    ),
                                    "--"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "payAmount",
                      label: _vm.$t("ad-analysis::成交额"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$dataCheck(
                                    _vm.formatNumberMix(
                                      scope.row.payAmount,
                                      2,
                                      ""
                                    ),
                                    "--"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "roi",
                      label: "ROI",
                      formatter: function (row) {
                        return (
                          "" +
                          (row.roi ? _vm.formatNumberMix(row.roi, 2, "") : "--")
                        )
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 12, md: 24, sm: 24, xl: 12 } },
            [
              _c("reportCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingSale.salesEcharts,
                    expression: "loadingSale.salesEcharts",
                  },
                ],
                style: "height: " + _vm.reportHeight + ";",
                attrs: { config: _vm.salesEcharts },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-row",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.params.adSource === 1,
              expression: "params.adSource === 1",
            },
          ],
          attrs: { gutter: 20 },
        },
        [
          _c(
            "el-col",
            { attrs: { lg: 12, md: 24, sm: 24, xl: 12 } },
            [
              _c(
                "reportCard",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loadingSale.trendData,
                      expression: "loadingSale.trendData",
                    },
                  ],
                  staticClass: "trend-card",
                  style: "height: " + _vm.reportHeight + ";",
                  attrs: { config: _vm.trendData },
                },
                [
                  _c("template", { slot: "other" }, [
                    _c(
                      "div",
                      { staticClass: "select-group" },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "select-type",
                            on: { change: _vm.getTrendData },
                            model: {
                              value: _vm.measure1,
                              callback: function ($$v) {
                                _vm.measure1 = $$v
                              },
                              expression: "measure1",
                            },
                          },
                          _vm._l(_vm.trendOptions, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: {
                                disabled: _vm.measure2 === item.value,
                                label: item.label,
                                value: item.value,
                              },
                            })
                          }),
                          1
                        ),
                        _vm._v(" VS "),
                        _c(
                          "el-select",
                          {
                            staticClass: "select-type",
                            on: { change: _vm.getTrendData },
                            model: {
                              value: _vm.measure2,
                              callback: function ($$v) {
                                _vm.measure2 = $$v
                              },
                              expression: "measure2",
                            },
                          },
                          _vm._l(_vm.trendOptions, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: {
                                disabled: _vm.measure1 === item.value,
                                label: item.label,
                                value: item.value,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { lg: 12, md: 24, sm: 24, xl: 12 } },
            [
              _c("reportCard", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingSale.adTransData,
                    expression: "loadingSale.adTransData",
                  },
                ],
                style: "height: " + _vm.reportHeight + ";",
                attrs: { config: _vm.adTransData },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        {
          staticStyle: { margin: "16px 0" },
          attrs: { "body-style": { padding: "16px" } },
        },
        [
          _c(
            "div",
            { staticClass: "table-search" },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", "align-items": "center" } },
                [
                  _c("z-select", {
                    staticStyle: { "margin-right": "20px" },
                    attrs: {
                      filterable: "",
                      clearable: "",
                      placeholder: _vm.$t("ad-analysis::placeholder_account"),
                      options: _vm.accounts,
                      "popper-append-to-body": false,
                      disabled: _vm.currentType > 1,
                    },
                    on: { change: _vm.getAdsTableData },
                    model: {
                      value: _vm.form.adAccountId,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "adAccountId", $$v)
                      },
                      expression: "form.adAccountId",
                    },
                  }),
                  _c("div", { staticClass: "effect--split" }, [
                    _vm.currentType > 1
                      ? _c("span", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("ad-analysis::adAccount")) +
                              "： "
                          ),
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.clickTableSeries(_vm.currentRow, 1)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.currentRow.adAccountName))]
                          ),
                        ])
                      : _vm._e(),
                    _vm.currentType > 2
                      ? _c("span", [
                          _vm._v(
                            " >> " +
                              _vm._s(_vm.$t("ad-analysis::adSeries")) +
                              "： "
                          ),
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.clickTableSeries(_vm.currentRow, 2)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.currentRow.adCampaignName))]
                          ),
                        ])
                      : _vm._e(),
                    _vm.currentType > 3
                      ? _c("span", [
                          _vm._v(
                            " >> " +
                              _vm._s(_vm.$t("ad-analysis::adGroup")) +
                              "： "
                          ),
                          _c(
                            "a",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.clickTableSeries(_vm.currentRow, 3)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.currentRow.adAdsetName))]
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  attrs: { icon: "el-icon-edit" },
                  on: { click: _vm.handleTableHeader },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("system::common::editorHeader-table::btn")
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
          _c("editor-header-table", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.TableLoading,
                expression: "TableLoading",
              },
            ],
            ref: "editorTable",
            attrs: {
              data: _vm.tableDataList,
              pagination: _vm.pagination,
              "table-name": _vm.tableName,
              fixTableHeaderList: _vm.fixTableHeaderList,
              columns: _vm.columns,
              defaultColumns: _vm.columns,
              maxHeight: 350,
            },
            on: {
              "update:pagination": function ($event) {
                _vm.pagination = $event
              },
              "page-change": _vm.getAdsTableData,
            },
            scopedSlots: _vm._u([
              {
                key: "date",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.$dataCheck(row.date)))]),
                  ]
                },
              },
              {
                key: "adAccountName",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    (
                      _vm.sourceType == 2
                        ? row.sourceType == "0"
                          ? _vm.currentType < 4
                          : _vm.currentType < 2
                        : _vm.currentType < 4
                    )
                      ? _c(
                          "a",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.clickTableSeries(row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getTableSeries(row, _vm.currentType)
                                ) +
                                " "
                            ),
                          ]
                        )
                      : _c("span", [
                          _vm._v(
                            _vm._s(_vm.getTableSeries(row, _vm.currentType))
                          ),
                        ]),
                  ]
                },
              },
              {
                key: "tableSeriesHeader",
                fn: function () {
                  return [_c("div", [_vm._v(_vm._s(_vm.getTableHeader()))])]
                },
                proxy: true,
              },
              {
                key: "shopName",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.$dataCheck(row.shopName)))]),
                  ]
                },
              },
              {
                key: "adName",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.$dataCheck(row.adName)))]),
                  ]
                },
              },
              {
                key: "saleAmount",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        "$" +
                          _vm._s(
                            _vm.$dataCheck(
                              _vm.formatNumberMix(row.saleAmount, 2, ","),
                              "0"
                            )
                          )
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "adSpend",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        "$" +
                          _vm._s(
                            _vm.$dataCheck(
                              _vm.formatNumberMix(row.adSpend, 2, ","),
                              "0"
                            )
                          )
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "roi",
                fn: function (ref) {
                  var row = ref.row
                  return [_c("span", [_vm._v(_vm._s(_vm.$dataCheck(row.roi)))])]
                },
              },
              {
                key: "coverCnt",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.$dataCheck(row.coverCnt)))]),
                  ]
                },
              },
              {
                key: "clickCnt",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.$dataCheck(row.clickCnt)))]),
                  ]
                },
              },
              {
                key: "clickRate",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$dataCheck(
                            _vm.formatNumberMix(row.clickRate, 2, ","),
                            "0"
                          )
                        ) + "%"
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "payTransRate",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$dataCheck(
                            _vm.formatNumberMix(row.payTransRate, 2, ","),
                            "0"
                          )
                        ) + "%"
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "transFeePer",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        "$" +
                          _vm._s(
                            _vm.$dataCheck(
                              _vm.formatNumberMix(row.transFeePer, 2, ","),
                              "0"
                            )
                          )
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "customerPrice",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        "$" +
                          _vm._s(
                            _vm.$dataCheck(
                              _vm.formatNumberMix(row.customerPrice, 2, ","),
                              "0"
                            )
                          )
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "addToCart",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.$dataCheck(row.addToCart)))]),
                  ]
                },
              },
              {
                key: "costPerCart",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        "$" + _vm._s(_vm.$dataCheck(row.costPerCart, "0"))
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "paymentCnt",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$dataCheck(
                            _vm.formatNumberMix(row.paymentCnt, 0, ","),
                            "0"
                          )
                        )
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "paymentAmount",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        "$" + _vm._s(_vm.$dataCheck(row.paymentAmount, "0"))
                      ),
                    ]),
                  ]
                },
              },
              {
                key: "orderCnt",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [_vm._v(_vm._s(_vm.$dataCheck(row.orderCnt)))]),
                  ]
                },
              },
              {
                key: "cpc",
                fn: function (ref) {
                  var row = ref.row
                  return [_c("span", [_vm._v(_vm._s(_vm.$dataCheck(row.cpc)))])]
                },
              },
              {
                key: "cpm",
                fn: function (ref) {
                  var row = ref.row
                  return [_c("span", [_vm._v(_vm._s(_vm.$dataCheck(row.cpm)))])]
                },
              },
              {
                key: "addToCartValue",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$dataCheck(
                            _vm.formatNumberMix(row.addToCartValue, 2, ",")
                          )
                        )
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("editModal", {
        attrs: { drawRow: _vm.drawRow },
        on: { save: _vm.reset },
        model: {
          value: _vm.editVisable,
          callback: function ($$v) {
            _vm.editVisable = $$v
          },
          expression: "editVisable",
        },
      }),
      _c("googleEditModal", {
        attrs: { drawRow: _vm.drawRow },
        on: { save: _vm.reset },
        model: {
          value: _vm.googleEditVisable,
          callback: function ($$v) {
            _vm.googleEditVisable = $$v
          },
          expression: "googleEditVisable",
        },
      }),
      _c("CardSetting", {
        attrs: { list: _vm.cardSetting, type: _vm.params.adSource },
        on: { onSave: _vm.changeCardSetting },
        model: {
          value: _vm.showSetting,
          callback: function ($$v) {
            _vm.showSetting = $$v
          },
          expression: "showSetting",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }